<style scoped lang="scss" type="text/scss">
    .special-competition-selector-panel-container {
        display: flex;
        overflow: auto;

        .special-competition-item {
            height: 5rem;
            width: 14rem;
            min-width: 14rem;
        }
    }
</style>

<template>
    <div class="special-competition-selector-panel-container">
        <add-block v-if="hasAdminEditablePermission" reversed size="small" class="special-competition-item" @click.native="showEditor"></add-block>
        <special-competition-item v-for="(specialCompetition, index) in specialCompetitions" :key="index"
                                  :active="currentSpecialCompetitionId === specialCompetition.id"
                                  @click.native="changeSpecialCompetitionId(specialCompetition.id)"
                                  @call-edit="showUpdateEditor(specialCompetition.id, ...arguments)"
                                  @call-remove="remove(specialCompetition.id, ...arguments)">
            {{ specialCompetition.name }}
        </special-competition-item>

        <popup :visible.sync="isEditorVisible"
               :is-update="isUpdateMode"
               :id="updateId"
               :deletable="isUpdateMode"
               @need-reload="reloadSpecialCompetitions"
        >
        </popup>
    </div>
</template>

<script>
    import AddBlock from '../../../../../../components/add-block/index';
    import SpecialCompetitionItem from './item';
    import Popup from './popup';

    export default {
        name: '',
        components: {
            AddBlock,
            SpecialCompetitionItem,
            Popup
        },
        data () {
            return {
                isEditorVisible: false,
                isUpdateMode: false,
                updateId: null,
                specialCompetitions: []
            };
        },
        computed: {
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            },
            currentSpecialCompetitionId () {
                return this.$store.state.competition.currentSpecialCompetitionId;
            },
            hasAdminEditablePermission () {
                return this.$store.getters['user/hasAdminEditablePermission'];
            }
        },
        watch: {
            currentCompetitionId: {
                immediate: true,
                handler (currentCompetitionId) {
                    if (currentCompetitionId === null || currentCompetitionId === undefined) return;
                    this.reloadSpecialCompetitions().then(() => {
                    });
                }
            }
        },
        methods: {
            showEditor () {
                this.updateId = null;
                this.isUpdateMode = false;
                this.isEditorVisible = true;
            },
            showUpdateEditor (id) {
                this.updateId = id;
                this.isUpdateMode = true;
                this.isEditorVisible = true;
            },
            remove (id, callback) {
                this.$deleteConfirm().then(_ => {
                    this.$normalRequest('competition/deleteSpecialCompetition', {id}, '删除成功').then(_ => {
                        this.reloadSpecialCompetitions().then(_ => {
                            callback();
                        });
                    }).catch(_ => {
                        callback();
                    });
                }).catch(_ => {
                    callback();
                });
            },
            reloadSpecialCompetitions () {
                return this.$store.dispatch('competition/loadSpecialCompetitions', {
                    competition_id: this.currentCompetitionId
                }).then(response => {
                    this.specialCompetitions = response.data;
                });
            },
            changeSpecialCompetitionId (id) {
                this.$store.commit('competition/updateCurrentSpecialCompetitionId', id);
            }
        }
    };
</script>
